<div class="corretores">

  <div id="carouselCorretores" class="carousel slide" data-bs-ride="carousel" data-bs-interval="3000"
    style="width:100%">

    <!-- Indicadores -->
    <div class="carousel-indicators" *ngIf="!mobile">
      <button *ngFor="let group of groupedCorretores; let i = index" [attr.data-bs-target]="'#carouselCorretores'"
        [attr.data-bs-slide-to]="i" [class.active]="i === 0"></button>
    </div>

    <!-- Slides -->
    <div class="carousel-inner">
      <div *ngFor="let group of groupedCorretores; let i = index" class="carousel-item" [class.active]="i === 0">
        <div class="cards">
          <div class="corretor-card" *ngFor="let corretor of group" (click)="acessaCorretor(corretor.codigo)">
            <div class="image-container">
              <img [src]="corretor.avatar" alt="Imagem do corretor">
            </div>
            <div class="div-img-texto-corretor">
              <p class="corret-nome">{{ corretor.nome }}</p>
              <p class="corret-creci">CRECI: {{ corretor.creci }}</p>
              <p class="corret-cargo">{{ corretor.cargo }}</p>
              <div class="div-corretor-icon">
                <a [href]="'mailto:' + corretor.email" title="Enviar e-mail">
                  <i class="fa-sharp fa-solid fa-envelope"></i>
                </a>
                <a [href]="formatarWhatsapplink(corretor.telefone)" target="_blank" title="Enviar WhatsApp">
                  <i class="fa-brands fa-whatsapp"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Controles de navegação -->
    <div style="display: flex; height: 100%; justify-content: center; align-items: center;">
      <button class="carousel-control-prev" style="justify-content: end; width: 10%;" type="button"
        data-bs-target="#carouselCorretores" data-bs-slide="prev" *ngIf="!mobile">
        <div class="circle-icon">
          <svg style="margin-left:-3px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="26"
            fill="#000" stroke="#000" stroke-width="2" class="size-1" transform="scale(-1, 1)">
            <path fill-rule="evenodd"
              d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
              clip-rule="evenodd" />
          </svg>
        </div>
      </button>
      <button class="carousel-control-next" style="justify-content: start; width: 10%;" type="button"
        data-bs-target="#carouselCorretores" data-bs-slide="next" *ngIf="!mobile">
        <div class="circle-icon">
          <svg style="margin-right:-3px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="26"
            fill="#000" stroke="#000" stroke-width="2" class="size-1">
            <path fill-rule="evenodd"
              d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
              clip-rule="evenodd" />
          </svg>
        </div>
      </button>
    </div>
  </div>
</div>